import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  de: {
    translation: {
      Welcome: 'Willkommen 124',
      'form#required': 'Das ist der Pflichtfeld',
    },
  },
};

i18n.use(initReactI18next).init({
  debug: !!localStorage.getItem('DEBUG_I18N'),
  resources,
  lng: 'de',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
